import { useCallback, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Switch, SwitchProps, message, Modal } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useQaContext } from 'views/Aide/Qa/Context';

export interface StatusSwitchProps extends SwitchProps {
  storeGroup: Store.StoreGroup;
  updateStatus: (body: {
    id: Store.StoreGroup['id'];
    status: Store.StoreGroup['status'];
  }) => Promise<any>;
}

const ConfirmContent = styled.ul`
  width: 340px;
  padding-left: 15px;
  margin: 0;
`;

function StatusSwitch(props: StatusSwitchProps) {
  const { storeGroup, updateStatus, ...otherProps } = props;
  const { platform } = useQaContext();
  const { t } = useTranslate();
  const noNightWatch = useMemo(() => platform === 'TOKOPEDIA', [platform]);

  const { id, status } = storeGroup;

  const [loading, setLoading] = useState(false);

  const update = useCallback(
    (checked: boolean) => {
      setLoading(true);

      return updateStatus({
        id,
        status: checked ? 'VALID' : 'INVALID',
      })
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          message.error(t('storeGroup.修改店铺配置组状态失败，请稍后再试'));
        });
    },
    [id, updateStatus, t],
  );

  const handleChange = useCallback(
    (checked: boolean) => {
      if (checked) {
        update(checked);
      } else {
        Modal.confirm({
          title: t('storeGroup.确认要关店铺配置组吗？'),
          content: (
            <ConfirmContent>
              <li>{t('storeGroup.关闭后该店铺配置组的机器人将不再自动回复话术；')}</li>
              {!noNightWatch ? <li>{t('storeGroup.值守模式也将一并关闭哦')}</li> : null}
            </ConfirmContent>
          ),
          onOk: () => update(checked),
        });
      }
    },
    [update, noNightWatch, t],
  );

  return (
    <Switch
      checkedChildren={t('storeGroup.启用中')}
      unCheckedChildren={t('storeGroup.未启用')}
      loading={loading}
      checked={status === 'VALID'}
      onChange={handleChange}
      {...otherProps}
    />
  );
}

export default StatusSwitch;
